import type { HostAdapter } from "../core/types.js";

export const wpsHost: HostAdapter = {
  name: "wps-writer",
  version: "unknown",
  async getSelectionText() {
    const app = getWpsApplication();
    const selection = app?.ActiveWindow?.Selection || app?.Selection;
    const text = selection?.Text || selection?.Range?.Text;
    return typeof text === "string" ? text : "";
  },
  async getDocumentText() {
    const app = getWpsApplication();
    const document = app?.ActiveDocument;
    const text = document?.Content?.Text || document?.Range?.Text || document?.Text;
    return typeof text === "string" ? text : "";
  },
  supportsSelection() {
    return true;
  }
};

function getWpsApplication(): any {
  const wpsGlobal = window.wps as any;
  if (wpsGlobal?.WpsApplication) {
    return wpsGlobal.WpsApplication();
  }

  if (wpsGlobal?.Application) {
    return wpsGlobal.Application;
  }

  throw new Error("WPS JS API is not available.");
}
